// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qy_Bfs8_klBBs6 {\n  height: 20px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 70%;\n  margin: 0 auto;\n}\n.qy_Bfs8_klBBs6::before {\n  content: '';\n  display: block;\n  width: 100%;\n}\n.miXwxPzTyVWjhb::before {\n  border-top: 2px solid var(--ds-border, #091e4224);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCard": "qy_Bfs8_klBBs6",
	"singleHorizontalLine": "miXwxPzTyVWjhb"
};
export default ___CSS_LOADER_EXPORT___;
